<div class="text-viewer" *ngIf="trial">
  <div class="text-area">
    <gen-section-expander header="Brief Title" [body]="brief_title" [visible]="true"></gen-section-expander>
    <gen-section-expander header="Official Title" [body]="official_title"></gen-section-expander>
    <gen-section-expander header="Brief Summary" [body]="brief_summary" [visible]="true"></gen-section-expander>
    <gen-section-expander header="Detailed Description" [body]="detailed_description"></gen-section-expander>
    <gen-section-expander header="Study Arms" [body]="arm_groups"></gen-section-expander>
    <gen-section-expander header="Eligibility" [body]="eligibility" [visible]="true"></gen-section-expander>
  </div>
  <div class="footer">
    <span class="legend">Legend:</span>
    <span class="legend hugene">Gene</span>
    <span class="legend resposres">Aberration</span>
    <span class="legend drug">Drug</span>
    <span class="legend disease">Disease</span>
    <span class="legend l10n_def">Abbreviation</span>
  </div>
</div>
